<template>
  <v-list-item @click="copySimpleHtml">
    <v-list-item-icon class="mr-2">
      <v-icon>mdi-content-copy</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>簡易HTMLコピー</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  props: {
    postId: {
      type: Number,
      required: true
    }
  },
  methods: {
    exportPostHtml: function (postId) {
      return axios.get(`/api/posts/${postId}/simple_html_export`).then(
        ({ data }) => {
          return deserialize(data).data.exportedHtml
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.messages
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    clipboardItemData: (htmlText) => {
      const type = 'text/html'
      const blob = new Blob([htmlText], { type })
      /* eslint no-undef: 0 */
      return [new ClipboardItem({ [type]: blob })]
    },
    copySimpleHtml: async function () {
      if (!navigator.clipboard) {
        const payload = {
          status: 500,
          message:
            'clipboardAPIを利用するために、https環境で実行してください。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      this.$store.dispatch('LoaderStore/displayLoader')
      const exportedHtml = await this.exportPostHtml(this.postId)

      const data = this.clipboardItemData(exportedHtml)

      navigator.clipboard
        .write(data)
        .then(
          () => {
            const payload = {
              status: 200,
              message: '保存済みの記事の内容をクリップボードにコピーしました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: 500,
              message: `コピーできませんできませんでした（${error}）`
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
